import { useAtomValue, useSetAtom } from '~shared/lib/atom-state';

import { hasVoucherAtom, setHasVoucherAtom } from './atoms';

export const useHasVoucher = () => useAtomValue(hasVoucherAtom);

export const useSetHasVoucher = () => useSetAtom(setHasVoucherAtom);
